
/* eslint-disable complexity */
import React, { useEffect, useState } from "react";
import "./ConditionSearchHistoryMsg.less";
import { Radio, Space, DatePicker } from "antd";
import { connect } from "dvajs";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import { useTranslation } from "react-i18next";
import ChatState from "@/types/chat/State";
import { employeeToUid } from "@/utils/chat/message";
import { SelectorMode, UserSelTab } from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import { ListItemData } from "@/components/ListItem";
import lodashGet from "lodash/get";
import { SearchGlobalContext } from "../utils";
import IconFont from "@/components/icon";
import zhCN from "antd/es/date-picker/locale/zh_CN";
import dayjs from "dayjs";

function ConditionSearchHistoryMsg(props: any) {
    const {
        currentEmployee,
        userData,
        setSessionType,
        setMsgType,
        onClose,
        setSenderList,
        setMsgTime
    } = props;
    const { sessionType, msgType, senderList, msgTime } = React.useContext(
        SearchGlobalContext
    );
    const { t } = useTranslation("common");
    const [sender, setSender] = useState("");
    const onChange = (e: any, radioType?: string) => {
        if (radioType === "msgType") {
            setMsgType(e.target.value);
        } else {
            setSessionType(e.target.value);
        }
    };

    const handleClear = (type: string) => {
        switch(type){
            case "all":
                setSessionType("");
                setMsgType("");
                setSenderList("");
                setSender("");
                setMsgTime([null, null]);
                break
            case "msg":
                setMsgType("");
                break;
            case "session":
                setSessionType("");
                break;
            case "sender":
                setSender("");
                setSenderList([]);
                break;
            case "time":
                setMsgTime([null, null]);
                break;
        }
    }
    // 调起人员选择器
    const openSelector = () => {
        openUserSelectionDefaultModal(
            {
                title: t("select-sender"),
                currentUser: employeeToUid(currentEmployee),
                mode: SelectorMode.user,
                tabs: ["recent", "group"],
                tabSort: [{ tab: UserSelTab.recent, sort: 1 }],
                resultUsers: senderList,
                frozenIds: senderList?.length ? senderList.map((item: any) => item.id) : []
            },
            (data, close) => {
                const selectedData = lodashGet(data, "data.result", []) as ListItemData[];
                const list = selectedData.map((item: any) => {
                    return {
                        ...item,
                        checked: true,
                        visible: false
                    }
                });
                setSenderList(list);
                close();
            },
            userData
        );
    };

    useEffect(() => {
        if (senderList?.length > 0) {
            let name = "";
            senderList.forEach((item: any) => {
                name ? name = `${name}、${item.name}` : name = item.name;
            });
            setSender(name);
        };
    }, [senderList])

    return (
        <div className="condition_msg">
            <div className="condition_header">
                <div
                    className={`condition_title ${
                    (sessionType || msgType || senderList?.length !== 0 || msgTime[0] || msgTime[1]) ? "Highlight" : ""
                    }`}
                >
                    <IconFont type="iconpc_ic_tjshaixuan_search" style={{ marginRight: 3 }} />
                    {(sessionType || msgType || senderList?.length !== 0 || msgTime[0] || msgTime[1])
                    ? "已启用筛选"
                    : t("Condition.conditional filtering")}
                </div>
                <div className="onClear">
                    {(sessionType || msgType || senderList?.length !== 0 || msgTime[0] || msgTime[1]) && (
                    <>
                        <span
                            className="text"
                            onClick={() => {
                                handleClear("all");
                            }}
                        >
                            {t("Condition.clearAll")}
                        </span>
                        <div className="line" />
                    </>
                    )}
                    <IconFont
                        type="iconic_pc_im_deletee"
                        onClick={() => {
                            onClose();
                        }}
                    />
                </div>
            </div>
            <div className="condition_content">
                <div className="sender">
                    <div className="filter_item_title">
                        <div className="title_left">发送人</div>
                        {senderList?.length !== 0 && (
                            <div
                                className="title_right"
                                onClick={() => {
                                    handleClear("sender");
                                }}
                            >
                                {t("Condition.clearAll")}
                            </div>
                        )}
                    </div>
                    <div
                        className={`${sender ? "include_select" : ""} sender_selected`}
                        onClick={openSelector}
                    >
                        {sender ? sender : " 点击选择"}
                    </div>
                </div>
                <div className="time">
                    <div className="filter_item_title">
                        <div className="title_left">发送时间</div>
                        {(msgTime[0] || msgTime[1]) && (
                            <div
                                className="title_right"
                                onClick={() => {
                                    handleClear("time");
                                }}
                            >
                                {t("Condition.clearAll")}
                            </div>
                        )}
                    </div>
                    <DatePicker
                        className="date_picker_begin"
                        value={msgTime[0]}
                        placeholder="开始时间"
                        locale={zhCN}
                        disabledDate={(current: any) => {
                            return current && (dayjs().isBefore(current, "day") || dayjs(current).isAfter(msgTime[1], "day"));
                        }}
                        onChange={(value: any) => {
                            setMsgTime([value]);
                        }}
                    />
                    <DatePicker
                        className="date_picker_end"
                        value={msgTime[1]}
                        placeholder="截止时间"
                        locale={zhCN}
                        disabledDate={(current: any) => {
                            return current && (dayjs(current).isBefore(msgTime[0], "day") || dayjs().isBefore(current, "day"));
                        }}
                        onChange={(value: any) => {
                            setMsgTime([msgTime[0], value]);
                        }}
                    />
                </div>
                <div className="session_type">
                    <div className="filter_item_title">
                        <div className="title_left">会话类型</div>
                        {sessionType && (
                            <div
                                className="title_right"
                                onClick={() => {
                                    handleClear("session");
                                }}
                            >
                                {t("Condition.clearAll")}
                            </div>
                        )}
                    </div>
                    <Radio.Group value={sessionType} onChange={onChange}>
                        <Radio value="all" style={{ marginRight: "44px", marginBottom: "8px" }}>全部</Radio>
                        <Radio value="single">单聊</Radio>
                        <Radio value="group">群聊</Radio>
                    </Radio.Group>
                </div>
                <div className="msg_type">
                    <div className="filter_item_title">
                        <div className="title_left">消息类型</div>
                        {msgType && (
                            <div
                                className="title_right"
                                onClick={() => {
                                    handleClear("msg");
                                }}
                            >
                                {t("Condition.clearAll")}
                            </div>
                        )}
                    </div>
                    <Radio.Group value={msgType} onChange={(e: any) => {onChange(e, "msgType")}}>
                        <Radio value="all" style={{ marginRight: "44px", marginBottom: "8px" }}>全部</Radio>
                        <Radio value="file">文件</Radio>
                        <Radio value="card">卡片</Radio>
                    </Radio.Group>
                </div>
            </div>
        </div>
    );
}
function mapStateToProps({ user, chat}: { user: any; chat: ChatState}) {
    return {
      userData: user.userData ? user.userData.user : {},
      currentEmployee: chat.currentEmployee
    };
}
function mapDispatchToProps() {
    return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(ConditionSearchHistoryMsg);
